import videojs from 'video.js'
import { BaseButton } from '|>/components/base'
import { Events } from '|>/shared/events'
import { isChromecastAPIAvailable } from './plugin/lib'

export const createChromecastButton = () => {
  class ChromecastButton extends BaseButton {
    isChromecastConnected: boolean = false
    labelEl?: HTMLElement
    isCastOptionAllowed: Events.Player.IsCastOptionAllowed | undefined

    constructor(player, options) {
      super(player, options)

      this.on('mouseover', this.handleMouseOver)
      this.on('mouseout', this.handleMouseOut)

      this.updateShowState()

      this.player_.on(
        'chromecastConnected',
        this.onChromecastConnected.bind(this)
      )
      this.player_.on(
        'chromecastDisconnected',
        this.onChromecastDisconnected.bind(this)
      )
      this.player_.on(
        'chromecastDevicesAvailable',
        this.updateShowState.bind(this)
      )
      this.player_.on(
        'chromecastDevicesUnavailable',
        this.updateShowState.bind(this)
      )

      this.controlText('Open Chromecast menu')

      this.player_.on(
        Events.Player.IsCastOptionAllowed,
        (_event, data: Events.Player.IsCastOptionAllowed) => {
          this.isCastOptionAllowed = data
        }
      )
    }

    override buildCSSClass() {
      return (
        'vjs-chromecast-button ' +
        (this.isChromecastConnected ? 'vjs-chromecast-casting-state ' : '') +
        super.buildCSSClass()
      )
    }

    override handleClick() {
      if (
        this.isCastOptionAllowed &&
        typeof this.isCastOptionAllowed === 'function'
      ) {
        const isAllowed = this.isCastOptionAllowed()

        if (!isAllowed) {
          return
        }
      }

      this.player().trigger('chromecastRequested')
    }

    /**
     * Handles `chromecastConnected` player events.
     */
    onChromecastConnected() {
      this.isChromecastConnected = true
      this.reloadCSSClasses()
    }

    /**
     * Handles `chromecastDisconnected` player events.
     */
    onChromecastDisconnected() {
      this.isChromecastConnected = false
      this.reloadCSSClasses()
    }

    /**
     * Function to trigger if chromecast button should be shown.
     */
    updateShowState() {
      if (isChromecastAPIAvailable()) {
        this.show()
      } else {
        this.hide()
      }
    }

    /**
     * Re-calculates which CSS classes the button needs and sets them on the buttons'
     * DOMElement.
     */
    reloadCSSClasses() {
      if (!this.el_) {
        return
      }
      this.el_.className = this.buildCSSClass()
    }

    handleMouseOver() {
      this.player_.addClass('vjs-chromecast-button')
    }

    handleMouseOut() {
      this.player_.removeClass('vjs-chromecast-button')
    }
  }

  videojs.registerComponent('chromecastButton', ChromecastButton as any)
}
